export default [
  {
    title: "footer.copyright.privacy-policy",
    routeName: "/home",
  },
  {
    title: "footer.copyright.cookie-policy",
    routeName: "/home",
  },
  {
    title: "footer.copyright.return-policy",
    routeName: "/home",
  },
  {
    title: "footer.copyright.public-contracts",
    routeName: "/home",
  },
];
